<template>
  <div>
    <Weather></Weather>
  </div>
</template>

<script>
import Weather from "@/components/weather/Weather.vue";

export default {
  name: "WeatherView",
  components: {
    Weather
  }
};
</script>

<style></style>
